export default __webpack_public_path__ + "static/media/ic-plus-white-24-px.58b2387c.svg";